"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.loyaltyProgram = exports.tier = void 0;
/**
 * Member tier level
 */
exports.tier = {
    BRONZE: 'BRONZE',
    SILVER: 'SILVER',
    GOLD: 'GOLD'
};
/**
 * The loyalty program the customer is enrolled in. Only present if isMember is true.
 */
exports.loyaltyProgram = {
    0: 'thuisvoordeel',
    1: 'zaakvoordeel',
    2: 'goedzitters'
};
